<template>
  <div class="content-container">
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <!-- <el-form-item label="用户名">
        <el-input
          v-model="formInline.username"
          placeholder="请输入用户名"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="手机(尾号)">
        <el-input v-model="formInline.usermobile" placeholder="请输入手机"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="onSearch">查询</el-button>
        <el-button type="primary" icon="el-icon-message" @click="sendSMS"
          :disabled="multipleSelection.length === 0">批量发短信</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"> </el-table-column>

      <el-table-column prop="username" label="用户名">
        <template slot-scope="scope">
          <div v-html="scope.row.username"></div>
        </template>
      </el-table-column>
      <el-table-column prop="usermobile" label="用户手机" width="180"></el-table-column>
      <el-table-column :formatter="formatBoolean" label="是否禁用" width="180">
        <template slot-scope="scope">
          <div>
            <el-tag type="success" v-if="scope.row.disabled">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lastLoginTime" label="最近登录时间" width="250"></el-table-column>
      <el-table-column prop="createtime" label="用户创建时间" width="250"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="redirectOrder(scope.row)">订单</el-button>
          <el-button type="text" @click="handleEdit(scope.row)">禁用</el-button>
          <el-button type="text" @click="handleViewCoupons(scope.row)">优惠券</el-button>
          <el-button type="text" @click="handleViewVipcards(scope.row)">vip卡</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleCurrentChange" :current-page.sync="page.currentPage"
      :page-size="page.pageSize" layout="total, prev, pager, next" :total="page.total"></el-pagination>
    <editUser v-if="isDialogShow" @closeForm="closeForm" @onSearch="onSearch" :userInfo2="userInfo" />
    <sendSMS v-if="isSendSMSShow" @closeForm="closeForm" @onSearch="onSearch" :SMSList="multipleSelection" />
    <el-dialog title="查看优惠券" :visible.sync="dialogVisible" width="1200px">
      <el-table :data="couponsList" height="500" border style="width: 100%">
        <el-table-column prop="couponid" label="优惠券编号"></el-table-column>
        <el-table-column prop="couponName" label="优惠券名称">
        </el-table-column>
        <el-table-column label="优惠券类型">
          <template slot-scope="scope">{{
            scope.row.type | filterType
          }}</template>
        </el-table-column>
        <el-table-column label="产品限制">
          <template slot-scope="scope">{{
            scope.row.limitedProductType | filterProductType
          }}</template>
        </el-table-column>
        <el-table-column label="抵价券数额/折扣率(%)">
          <template slot-scope="scope">{{ getCouponVal(scope.row) }}</template>
        </el-table-column>
        <el-table-column prop="isInPeriod" label="是否在有效期内">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isInPeriod">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </template></el-table-column>
        <el-table-column prop="extendInfo" label="扩展信息(抖音)">
          <template slot-scope="scope">
            {{ parseJson(scope.row.extendInfo) }}
          </template>
        </el-table-column>
        <el-table-column prop="isUsed" label="是否已经使用">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.isUsed">是</el-tag>
            <el-tag type="info" v-else>否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="有效日期" width="164">
          <template slot-scope="scope">
            {{ scope.row.startDate | formatDate }}
            <span style="text-align:center">~</span>
            {{ scope.row.expireDate | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="是否可用">
          <template slot-scope="scope">
            <el-tag type="success" effect="dark" v-if="scope.row.isEnable">可用</el-tag>
            <el-tag type="danger" effect="dark" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button type="text" @click="handleDeleteCoupon(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog title="查看VIP卡" :visible.sync="vipcardDialogVisible" width="1200px">
      <el-table :data="vipcardList" height="500" border style="width: 100%">
        <el-table-column prop="vipcardid" label="VIP卡编号"></el-table-column>
        <el-table-column prop="vipcardName" label="VIP卡名称">
        </el-table-column>
        <el-table-column label="产品限制">
          <template slot-scope="scope">{{
            scope.row.limitedProductType | filterProductType
          }}</template>
        </el-table-column>
        <el-table-column label="次数限制">
          <template slot-scope="scope">{{
            "每日" +
            scope.row.dailyLimitCount +
            ";" +
            "每周" +
            scope.row.weeklyLimitCount +
            ";" +
            "总数" +
            scope.row.totalLimitCount
          }}</template>
        </el-table-column>
        <el-table-column label="折扣率(%)">
          <template slot-scope="scope">{{ scope.row.zhekou }}</template>
        </el-table-column>
        <el-table-column label="天数">
          <template slot-scope="scope">{{ scope.row.dayCount }}</template>
        </el-table-column>
        <el-table-column label="有效日期" width="164">
          <template slot-scope="scope">
            {{ scope.row.startDate | formatDate }}
            <span style="text-align:center">~</span>
            {{ scope.row.expireDate | formatDate }}
          </template>
        </el-table-column>
        <el-table-column label="是否可用">
          <template slot-scope="scope">
            <el-tag type="success" effect="dark" v-if="scope.row.isEnable">可用</el-tag>
            <el-tag type="danger" effect="dark" v-else>禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="删除">
          <template slot-scope="scope">
            <el-button type="primary" effect="dark" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="vipcardDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import editUser from "./components/editUser";
import sendSMS from "./components/sendSMS";
import Coupon from "../../plugins/CouponClass";
export default {
  components: {
    editUser,
    sendSMS
  },
  data() {
    return {
      formInline: {
        user: "",
        region: ""
      },
      tableData: null,
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isDialogShow: false,
      isSendSMSShow: false,
      userInfo: null,
      dialogVisible: false,
      vipcardDialogVisible: false,
      couponsList: [],
      vipcardList: [],
      currentUserMobile: ""
    };
  },
  filters: {
    filterProductType(val) {
      return Coupon.limitedProductTypeList().find(ele => ele.id === val).name;
    },
    filterType(val) {
      return Coupon.typeList().find(ele => ele.id === val).name;
    }
  },
  methods: {
    onSearch() {
      let queryModel = {
        usermobile: this.formInline.usermobile,
        username: this.formInline.username,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };
      this.$axios(this.$urlMapping["查询用户"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    redirectOrder(userInfo) {
      this.$router.push({
        name: "order",
        query: {
          username: userInfo.username
        }
      });
    },

    handleDelete(row) {
      this.$confirm(
        "是否确认删除用户的该VIP卡【" + row.vipcardid + "】",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.$axios(this.$urlMapping["删除用户VIP关联"], {
          data: {
            id: row.id
          }
          // eslint-disable-next-line no-unused-vars
        }).then(() => {
          this.$notifySuccess();
          console.log(row);
          this.queryVipcardByUsername(row.username);
        });
      });
    },
    handleDeleteCoupon(row) {
      this.$confirm(
        "是否确认删除该优惠券【" + row.couponid + "】",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        this.$axios(this.$urlMapping["删除用户的优惠券"], {
          data: {
            userMobile: this.currentUserMobile,
            couponids: [row.couponid]
          }
        }).then(() => {
          this.$notifySuccess();
          this.queryUserCoupon(row.username);
        });
      });
    },
    async handleViewCoupons(userInfo) {
      console.log(userInfo);

      this.currentUserMobile = userInfo.usermobile;
      this.couponsList = [];
      await this.queryUserCoupon(userInfo.username);
      this.dialogVisible = true;
    },
    async handleViewVipcards(userInfo) {
      this.couponsList = [];
      await this.queryVipcardByUsername(userInfo.username);
      this.vipcardDialogVisible = true;
    },
    queryUserCoupon(username) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询用户的优惠券"], {
          data: {
            username
          }
        }).then(result => {
          this.couponsList = result;
          resolve();
        });
      });
    },
    queryVipcardByUsername(username) {
      return new Promise(resolve => {
        this.$axios(this.$urlMapping["查询用户的Vip卡"], {
          data: {
            username
          }
        }).then(result => {
          this.vipcardList = result;
          resolve();
        });
      });
    },
    closeForm() {
      this.isDialogShow = false;
      this.isSendSMSShow = false;
    },
    sendSMS() {
      this.isSendSMSShow = true;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleEdit(userInfo) {
      this.userInfo = userInfo;
      this.isDialogShow = true;
    },
    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSearch();
    },
    formatBoolean: function (row, column, cellValue) {
      var ret = ""; //你想在页面展示的值
      if (cellValue) {
        ret = "是"; //根据自己的需求设定
      } else {
        ret = "否";
      }
      return ret;
    },
    getCouponVal(item) {
      if (item.type === 1) {
        return `抵用券${item.discountAmount}元`;
      } else {
        return `折扣率${item.zhekou}%`;
      }
    },
    parseJson(jsonStr) {
      try {
        const obj = JSON.parse(jsonStr);
        return obj.douyin_orderId || '';
      } catch (e) {
        return jsonStr;
      }
    }
  },
  mounted() {
    this.onSearch();
  }
};
</script>

<style lang="less" scoped></style>
